import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from './config';

export interface ViewState {
  showCompletedMaterials: boolean;
}

const initialState: ViewState = {
  showCompletedMaterials: false,
};

export const viewSlice = createSlice({
  name: 'view',
  initialState,
  reducers: {
    setShowCompletedMaterials: (state, action: PayloadAction<boolean>) => {
      state.showCompletedMaterials = action.payload;
    },
    toggleShowCompletedMaterials: (state) => {
      state.showCompletedMaterials = !state.showCompletedMaterials;
    },
  },
});

export const selectView = (state: RootState) => state.view;

export const { setShowCompletedMaterials, toggleShowCompletedMaterials } = viewSlice.actions;
export default viewSlice.reducer;

